export default __webpack_public_path__ + "static/media/card-background.0eea1ae8.png";